/**
 * Contexto de la semana anterior para comparativas de nómina teachers.
 * Semana 1: sabatina ciclo actual + bonos y quincena del ciclo anterior (sem 4 y 3-4).
 */
export function getContextoSemanaAnterior(ciclo, selectedHeaders, cicloAnt) {
  if (selectedHeaders === 1) {
    return {
      id_ciclo: cicloAnt || ciclo.id_ciclo,
      semana: 4,
    };
  }
  return {
    id_ciclo: ciclo.id_ciclo,
    semana: selectedHeaders - 1,
  };
}

export function parseJsonField(val) {
  if (!val) return null;
  if (typeof val === 'object') return val;
  try {
    return JSON.parse(val);
  } catch (e) {
    return val;
  }
}

/** Snapshot del desglose por teacher (mismo contenido que exporta el Excel). */
export function buildDetalleSnapshot(teacher) {
  const campos = [
    'id_teacher', 'teacher', 'aceptado', 'hsbc', 'plantel', 'existeCategoria',
    'PAGO_SABADO', 'PAGO_DOBLES_SABADO', 'PAGO_DOBLE', 'REBAJES', 'pago_quincena',
    'bono_teacher', 'estatus_sabatina', 'estatus_quincena', 'estatus_bono',
    'HORAS_SABADO_FAST', 'HORAS_SABADO_INBI', 'HORAS_SABADO_TEENS', 'TOTAL_HORAS',
    'HORAS_ENTRE_SEMANA_FAST', 'HORAS_DOMINGO_FAST', 'HORAS_LMV_FAST',
    'HORAS_ENTRE_SEMANA_INBI', 'HORAS_DOMINGO_INBI', 'HORAS_LMV_INBI', 'HORAS_TOTALES',
    'categoria', 'categoria_lv', 'categoria_d', 'id_plantel',
  ];
  const snapshot = {};
  campos.forEach((k) => {
    if (teacher[k] !== undefined) snapshot[k] = teacher[k];
  });
  return snapshot;
}

/** Comparativas a persistir al generar requisición. */
export function buildComparativasPayload(vm) {
  const comparativas = [];

  comparativas.push({
    tipo: 1,
    tabla_anterior: vm.tabla2Comparativa,
    tabla_actual: vm.tabla1Comparativa,
    costo_hora_anterior: vm.costoHora1,
    costo_hora_actual: vm.costoHora2,
    notas: vm.notasSabatino || '',
  });

  if ([1, 3].includes(vm.selectedHeaders)) {
    comparativas.push({
      tipo: 2,
      tabla_anterior: vm.tabla2ComparativaQ,
      tabla_actual: vm.tabla1ComparativaQ,
      costo_hora_anterior: vm.costoHora1,
      costo_hora_actual: vm.costoHora2,
      notas: (typeof vm.notasQuincena === 'string' ? vm.notasQuincena : '') || '',
    });
  }

  if (vm.selectedHeaders === 1 && typeof vm.tablaBonos !== 'undefined') {
    comparativas.push({
      tipo: 3,
      tabla_bonos: vm.tablaBonos,
    });
  }

  return comparativas;
}

export function buildTeachersConDetalle(teachers) {
  return (teachers || [])
    .filter((el) => el.id_teacher != 100000 && el.teacher !== 'SIN TEACHER' && el.id_teacher != 0)
    .map((t) => ({
      ...t,
      detalle_snapshot: buildDetalleSnapshot(t),
    }));
}

/** Filas del desglose guardado para tabla / Excel. */
export function mapDetalleHistorialRows(detalle) {
  return (detalle || [])
    .map((d) => {
      const parsed = parseJsonField(d.detalle) || parseJsonField(d.detalle_json);
      if (parsed && parsed.id_teacher) {
        return parsed;
      }
      return {
        id_teacher: d.id_teacher,
        teacher: d.teacher,
        PAGO_SABADO: d.pago_sabado,
        pago_quincena: d.pago_quincena,
        PAGO_DOBLE: d.pago_dobles,
        REBAJES: d.rebajes,
        bono_teacher: d.bono_teacher,
      };
    })
    .filter((el) => el.id_teacher != 100000 && el.teacher !== 'TOTAL' && el.teacher !== 'SIN TEACHER' && el.id_teacher != 0);
}
